import React from 'react';
import { Switch } from '@/components/ui/switch';
import { Badge } from '@/components/ui/badge';

interface PricingToggleProps {
  isAnnual: boolean;
  onToggle: (val: boolean) => void;
}

export const PricingToggle: React.FC<PricingToggleProps> = ({ isAnnual, onToggle }) => {
  return (
    <div className="mb-16 flex items-center justify-center gap-4">
      <span className={`text-sm font-medium ${!isAnnual ? 'text-slate-900' : 'text-slate-500'}`}>Monthly</span>
      <Switch checked={isAnnual} onCheckedChange={onToggle} className="data-[state=checked]:bg-emerald-600" />
      <span className={`text-sm font-medium ${isAnnual ? 'text-slate-900' : 'text-slate-500'}`}>
        Yearly
        <Badge variant="secondary" className="ml-1.5 h-5 border-emerald-200 bg-emerald-50 px-1.5 py-0 text-[10px] text-emerald-700">
          Save ~17%
        </Badge>
      </span>
    </div>
  );
};
